class TemplateFiller {

    _debug_mode = false;

    getHtmlTemplate = function(templateID) {
        if (document.getElementById(templateID)) {
            return document.getElementById(templateID).text;
        }
        return false;
    }

    fillTemplate = function(templateID, fillData) {
        let self = this;
        try {
            var template = self.getHtmlTemplate(templateID);
            if (template) {
                return template.formatUnicorn(fillData);
            } else {
                return '';
            }
        } catch (e) {
            return '';
        }
    }


    get debug_mode() {
        return this._debug_mode;
    }

    set debug_mode(value) {
        this._debug_mode = value;
    }

}

String.prototype.formatUnicorn =  function () {
    "use strict";
    var str = this.toString();
    if (arguments.length) {
        var t = typeof arguments[0];
        var key;
        var args = ("string" === t || "number" === t) ?
            Array.prototype.slice.call(arguments)
            : arguments[0];

        for (key in args) {
            str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key]);
        }
    }

    return str;
}

window.TemplateFiller = new TemplateFiller();

module.exports = TemplateFiller;